import { ACTIONS } from '../enums/PermissionEnums';

export function Route(label, url, component, permissionKeys = null) {
    return {
        label: Array.isArray(label) ? label[0] : label,
        to: url,
        icon: Array.isArray(label) ? label[1] : 'pi pi-circle-on',
        component: component,
        permissionKeys:
            Array.isArray(permissionKeys) && permissionKeys.length === 0 ? null : permissionKeys,
        visibleOnRouter: true,
    };
}

export function RouteResource(label, PagesUrl, component, permissionKeys = null) {
    const routes = [];

    const routeList = Route(
        label,
        PagesUrl.list,
        component[0],
        Array.isArray(permissionKeys) && permissionKeys.length === 0 ? null : permissionKeys
    );

    routes.push(routeList);

    const getRoute = (to, action) => ({
        ...routeList,
        permissionKeys: Array.isArray(permissionKeys) ? [`${basePermission}_${action}`] : null,
        to,
        component: component[1],
        label: null,
    });

    let basePermission = null;
    if (Array.isArray(permissionKeys)) {
        basePermission = routeList.permissionKeys[0].split('_');
        basePermission.pop();
        basePermission = basePermission.join('_').trim();
    }

    routes.push(getRoute(PagesUrl.new, ACTIONS.INCLUIR));
    routes.push(getRoute(PagesUrl.edit, ACTIONS.EDITAR));
    routes.push(getRoute(PagesUrl.view, ACTIONS.CONSULTAR));

    return routes;
}
